@if (!hideHeader()) {
  <div class="permissions-configurator-header">
    <h3 class="header-title">{{ title() }}</h3>
    <p class="header-description">Configure what users with this role can do.</p>
  </div>
}

@if (!readOnly() && !disabled()) {
  <div class="presets-section">
    <span class="presets-label">Quick presets:</span>
    <div class="presets-chips">
      @for (preset of presets(); track preset.id) {
        <button
          type="button"
          class="preset-chip-button"
          [disabled]="disabled()"
          [attr.aria-label]="'Apply ' + preset.name + ' preset'"
          [attr.aut-id]="'preset-chip-' + preset.id"
          (click)="applyPreset(preset)"
        >
          <cm-chip color="primary" class="preset-chip">
            {{ preset.name }}
          </cm-chip>
        </button>
      }
    </div>
  </div>
}

<cm-accordion>
  @for (group of permissionGroupVms(); track group.name) {
    <cm-expansion-panel class="permissions-configurator-expansion-panel">
      <div cmExpansionPanelHeader class="group-header">
        <span class="group-name">{{ group.name }}</span>
        <div class="group-right">
          <span class="group-count">{{ group.description }}</span>
          @if (!readOnly() && !disabled()) {
            @if (!group.isFullySelected) {
              <cm-button
                variant="basic"
                [wrap]="false"
                (click)="selectAllInGroup(group); $event.stopPropagation()"
              >
                Select all
              </cm-button>
            }
            @if (group.selectedCount > 0) {
              <cm-button
                variant="basic"
                [wrap]="false"
                (click)="clearAllInGroup(group); $event.stopPropagation()"
              >
                Clear all
              </cm-button>
            }
          }
        </div>
      </div>

      <div class="permissions-grid">
        @for (permission of group.permissions; track permission.id + '|' + permission.isDisabled) {
          <div class="permission-item">
            @if (permission.isDisabled && permission.disabledReason) {
              <span [cmTooltip]="permission.disabledReason">
                <cm-checkbox
                  [checked]="permission.isSelected"
                  [disabled]="true"
                  [label]="permission.name"
                  (checkedChange)="togglePermission(permission.id)"
                />
              </span>
            } @else {
              <cm-checkbox
                [checked]="permission.isSelected"
                [disabled]="disabled() || readOnly() || permission.isDisabled"
                [label]="permission.name"
                (checkedChange)="togglePermission(permission.id)"
              />
            }
            @if (permission.description) {
              <span class="permission-description">{{ permission.description }}</span>
            }
          </div>
        }
      </div>
    </cm-expansion-panel>
  }
</cm-accordion>
